/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import echarts from 'echarts/lib/echarts';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import zip from 'lodash/zip';
import map from 'lodash/map';
import { injectIntl } from 'react-intl';
import format from 'date-fns/format';
import IntlMsg from 'lorautils/intl/IntlMsg';
import dashboardActions from 'loraactions/dashboard';
import callAPI from '@/api/callAPI';
import loadingImg from 'loraimages/chart_loading.gif';
import { transform, getCenterAndZoom } from 'lorautils/map';
import imgConnected from '../../images/green.svg';
import styles from './style.scss';

const defaultProps = {
  onZoom: () => {},
  onDrag: () => {},
};

const propTypes = {
  intl: PropTypes.object.isRequired,
  time: PropTypes.object.isRequired,
  devices: PropTypes.array.isRequired,
  dps: PropTypes.string.isRequired,
  dashId: PropTypes.string.isRequired,
  pushState: PropTypes.func.isRequired,
  getDeveui: PropTypes.func.isRequired,
  refreshState: PropTypes.number.isRequired,
  onZoom: PropTypes.func,
  onDrag: PropTypes.func,
};

const kOption = {
  tooltip: {
    trigger: 'axis',
    formatter: '{b} <br/>{a} : {c}',
  },
  xAxis: {
    type: 'category',
    name: 'x',
    splitLine: { show: false },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  yAxis: {
    type: 'value',
    name: 'y',
  },
  series: [],
  color: ['#1BBC9B'],
};

class MultipleMap extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      dps: props.dps.split(','),
    };
    this.initDom = false;
    this.markers = [];
    this.listeners = [];
    this.devices = props.devices;
    this.time = props.time;
    this.chartObj = {};
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.dashboard');
  }

  componentDidMount() {
    let tries = 0;
    const init = () => {
      try {
        this.initMap();
        this.updateData();
      } catch (e) {
        if (tries < 10) {
          tries += 1;
          setTimeout(init, 1000);
        }
      }
    };
    init();
    this.kName = {
      rssi: 'RSSI',
      drops: `${this.intlMsg.msg('map.drops')}`,
      snr: 'SNR',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { devices, dps, time, refreshState } = nextProps;
    if (devices !== this.props.devices) {
      this.devices = devices;
      if (this.map) {
        this.map.clearOverlays();
        this.updateData();
      }
    }
    if (time !== this.props.time) {
      this.time = time;
      if (this.initDom) {
        this.chartObj = {};
        this.initCharts();
        this.loadStats();
      }
    }
    if ((refreshState !== this.props.refreshState) && refreshState !== 0) {
      if (this.initDom) {
        this.initCharts('refresh');
        this.loadStats('refresh');
      }
    }
    this.setState({ dps: dps.split(',') });
  }

  componentWillUnmount() {
    map(zip(this.markers, this.listeners), ([marker, listener]) => {
      marker.removeEventListener('click', listener);
    });
    $('#mapdetail').empty();
    this.chartObj = null;
  }

  handleData(domId, dps, anyType) {
    const domPrt = $(`#${domId}`).parent();
    if (!anyType) {
      domPrt.next('.load').css('display', 'inline-block');
      domPrt.css('display', 'none');
      domPrt.next().next('.empty')
        .css('display', 'none');
    } else {
      domPrt.next().next('.empty')
        .css('display', 'none');
      domPrt.css('display', 'inline-block');
    }
    this.loadData(this.currentId, dps, anyType).then((res) => {
      domPrt.next('.load').css('display', 'none');
      const categories = [];
      const list = res.list.reverse();
      if (list.length === 0 && !anyType) {
        domPrt.next().next('.empty')
          .css('display', 'inline-block');
      } else {
        let option;
        const data = _.map(list, (l) => {
          categories.push(format(l.timestamp, 'DD/MM HH:mm:ss'));
          return l.metrics[dps];
        });
        if (anyType) {
          const originOption = this.chartObj[domId].getOption() || kOption;
          option = {
            ...originOption,
            series: [{ name: dps, type: 'line', data }],
            xAxis: { data: categories },
          };
        } else {
          option = Object.assign({}, kOption,
            {
              xAxis: { data: categories },
              yAxis: { name: dps },
              series: [{ name: dps, type: 'line', data }],
            },
          );
        }
        this.chartObj[domId].setOption(option);
        domPrt.css('display', 'inline-block');
      }
      _.delay(() => {
        const height = Math.ceil($('.BMap_bubble_content').parent().height() - 44);
        $('.dl-horizontal').css({ height: `${height}px`, overflowY: 'auto' });
      }, 100);
    }).catch(() => {});
  }

  loadData(item, dps, anyType) {
    const { from } = this.time;
    const to = anyType ? new Date() : this.time.to;
    return callAPI({ endpoint: '/lora/timeseries',
      method: 'POST',
      body: { nodeid: item, dps: [dps], from, to, limit: 1000 },
    });
  }

  loadStats(refresh) {
    callAPI({
      endpoint: `/lora/nodes/${this.currentId}/rxqos?download`,
    }).then((data) => {
      this.handleRxqos(data, refresh);
    });
  }

  handleRxqos(data, refresh) {
    const obj = { drops: [], snr: [], rssi: [] };
    const slots = [];
    try {
      data.list.reverse().forEach((item) => {
        slots.push(format(item.$time, 'MM-DD HH:mm:ss'));
        obj.drops.push(item.drops);
        obj.snr.push(item.lorasnr);
        obj.rssi.push(item.rssi);
      });
    } catch (err) {
      // nothing to do err
    }
    ['drops', 'rssi', 'snr'].forEach((item) => {
      const dom = document.querySelector(`.${item}`);
      const parent = $(dom).parent();
      const id = dom.getAttribute('id');
      parent.next('.load').css('display', 'none');
      if (data.list.length === 0) {
        if (refresh) {
          parent.next().next('.empty').css('display', 'none');
          parent.css('display', 'inline-block');
        } else {
          parent.next().next('.empty').css('display', 'inline-block');
        }
      } else {
        const originOption = this.chartObj[id].getOption() || kOption;
        const option = {
          ...originOption,
          yAxis: { name: this.kName[item] },
          xAxis: { data: slots },
          series: [
            {
              name: this.kName[item],
              type: 'line',
              data: obj[item],
              areaStyle: {
                normal: {
                  opacity: 0.1,
                },
              },
            },
          ],
        };
        this.chartObj[id].setOption(option);
        parent.css('display', 'inline-block');
      }
    });
  }

  initMap() {
    this.map = new BMap.Map('mapdetail');
    this.map.setMapStyle({ features: [] });
    this.map.setMaxZoom(16);
    this.map.setMinZoom(2);
    this.map.enableScrollWheelZoom();
    this.map.removeControl(this.navControl);
    this.map.removeControl(this.scaleControl);
    // eslint-disable-next-line
    this.navControl = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });
    // eslint-disable-next-line
    this.scaleControl = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT });

    this.map.addControl(this.navControl);
    this.map.addControl(this.scaleControl);
    this.map.addEventListener('zoomend', () => this.props.onZoom(this.map));
    this.map.addEventListener('dragend', () => this.props.onDrag(this.map));
  }

  updateData() {
    this.devices = transform(this.devices);
    this.devices.forEach((obj) => {
      this.addMarker(obj);
    });

    const points = this.devices.map(x => x.point);
    if (points.length === 1) {
      this.map.centerAndZoom(points[0], 16);
    } else if (points.length > 0) {
      // decide max span with at most 100 points
      const [center, zoom] = getCenterAndZoom(points.slice(0, 100));
      this.map.centerAndZoom(center, zoom);
    } else {
      this.map.centerAndZoom('深圳', 1);
    }
  }

  addMarker(item) {
    const opts = {
      title: '',
      width: 680,
      enableMessage: true,
    };

    const { pushState, dashId, getDeveui } = this.props;
    const that = this;
    const openInfo = () => {
      that.initDom = false;
      const info = that.info(item);
      const infoWin = new BMap.InfoWindow(info, opts);
      this.map.openInfoWindow(infoWin, item.point);
      setTimeout(() => {
        $('#infowin').click(() => {
          pushState(`/application/${item.appeui}/devices/${item.id}`);
        });
        $('.map-zoom').click((e) => {
          getDeveui([item.id]);
          const dps = e.target.getAttribute('data-dps');
          pushState(`/application/${item.appeui}/dashboard/${dashId}/${dps}`);
        });
        this.currentId = item.id;
        this.chartsDOM = document.querySelectorAll('.charts');
        this.chartObj = {};
        that.initDom = true;
        that.initCharts();
        this.loadStats();
      }, 300);
    };

    const icon = new BMap.Icon(imgConnected, new BMap.Size(20, 20));
    const marker = new BMap.Marker(item.point, { icon });
    marker.addEventListener('click', openInfo);
    this.map.addOverlay(marker);
    this.markers.push(marker);
    this.listeners.push(openInfo);
  }

  info(obj) {
    let charts = '';
    const style = 'width:300px;height:170px;text-align: center;margin:0 10px 10px;border:1px solid #efefef;';
    const renderDom = (item, index) => (
      `<div style="${style} display: none;position: relative;">
          <i class="fa fa-expand pull-right map-zoom" data-dps="${item}"></i>
          <div id="chart${index}" style="width:300px;height:170px;" class="${item} charts pull-left" data-dps="${item}">
          </div>
        </div>
        <div
         style="${style} padding-top:20px;" class="load pull-left">
         <img src="${loadingImg}" />
        </div>
        <div style="${style} display: none;" class="empty pull-left">
          <p class="text-left"
           style="margin-bottom:0;margin-left:10px;margin-top:10px;font-size:14px;font-weight:normal;">
            ${this.kName[item] || item}
          </p>
          <p style="line-height:120px;font-size:20px;color:#dadfe1;">${this.intlMsg.msg('chart.nodata')}</p>
        </div>
    `
    );
    this.state.dps.forEach((item, index) => {
      charts += renderDom(item, index);
    });
    ['drops', 'snr', 'rssi'].forEach((it, idx) => {
      const leng = this.state.dps.length;
      charts += renderDom(it, idx + leng);
    });
    return (
`
<div>
  <h4 style="font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, PingFang SC, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif; font-weight: 300; font-size: 14px;">
    ${obj.name}&nbsp;<a id="infowin">${obj.id}</a>
  </h4>
  <dl class="dl-horizontal clearfix" style="font-size: 12px; padding: 15px 5px; border-radius: 2px; border: 1px solid #efefef;">
    ${charts}
  </dl>
</div>
`
    );
  }

  initCharts(anyType) {
    $('.dl-horizontal').css({ overflowY: 'hidden' });
    this.chartsDOM.forEach((item) => {
      const id = item.getAttribute('id');
      const dps = item.getAttribute('data-dps');
      this.chartObj[id] = this.chartObj[id] ?
        this.chartObj[id] : echarts.init(document.getElementById(id));
      if (dps !== 'drops' && dps !== 'snr' && dps !== 'rssi') {
        this.handleData(id, dps, anyType);
      }
    });
  }

  render() {
    return <div id="mapdetail" style={{ height: '100%', width: '100%' }} />;
  }
}


MultipleMap.defaultProps = defaultProps;
MultipleMap.propTypes = propTypes;

const mapStateToProps = state => ({
  dps: state.dashboard.getDps,
  time: state.dashboard.getTimes,
  refreshState: state.dashboard.getRefreshCount,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDeveui: dashboardActions.getDeveui,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(
  MultipleMap,
  styles,
  { allowMultiple: true },
)));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/MultipleMap/index.jsx